exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note[data-v-458d51ba]{font-weight:400;font-size:smaller;color:grey}.title[data-v-458d51ba]{margin-bottom:8px}.option[data-v-458d51ba]{margin-top:-32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-458d51ba","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VoucherDetail.vue
// module id = Ne5B
// module chunks = 0